import React from 'react';
import Header from 'gatsby-theme-carbon/src/components/Header';

const CustomHeader = (props) => (
  <Header {...props}>
    Smart&nbsp;<span>Resident</span>
  </Header>
);

export default CustomHeader;
